import React from 'react';
import { calculateSLAStatus, formatDuration } from '../utils/helpers';
import { SLA_STATUS } from '../utils/constants';

const VehicleCard = ({ vehicle, currentStage, currentTime, isFocusMode }) => {
  const status = calculateSLAStatus(vehicle.entryTime, currentStage.slaMinutes, currentTime);
  const duration = formatDuration(vehicle.entryTime, currentTime);
  const isBreached = status === SLA_STATUS.BREACHED;
  const showCompact = isFocusMode && !isBreached;

  if (showCompact) {
    return (
      <div className="px-3 py-1.5 border border-white/5 bg-black/40 flex justify-between items-center opacity-40 hover:opacity-100 transition-opacity">
        <span className="font-mono-tech text-[10px] font-bold text-neutral-300 tracking-wider">
          {vehicle.regNumber.replace(' ', '_')}
        </span>
        <span className="font-mono-tech text-[8px] text-neutral-600 uppercase">
          {vehicle.make[0]}.{vehicle.model}
        </span>
      </div>
    );
  }

  const getStatusColor = () => {
    if (status === SLA_STATUS.BREACHED) return 'border-[#D71921] text-[#D71921] bg-[#D71921]/5';
    if (status === SLA_STATUS.WARNING) return 'border-[#FFB800] text-[#FFB800]';
    return 'border-white/10 text-white';
  };

  const formattedRevenue = vehicle.revenue
    ? `R ${vehicle.revenue.toLocaleString('en-ZA')}`
    : 'R —';

  return (
    <div className={`p-4 border bg-black transition-all duration-300 shadow-2xl ${getStatusColor()}`}>
      <div className="flex justify-between items-start mb-4">
        <div className="flex flex-col">
          <span className="font-mono-tech text-sm font-bold tracking-wider leading-none">
            {vehicle.regNumber.replace(' ', '_')}
          </span>
          <span className="font-mono-tech text-[9px] text-neutral-500 uppercase mt-1">
            {vehicle.make}_{vehicle.model}
          </span>
        </div>
        {vehicle.customerWait && (
          <div className="w-2.5 h-2.5 rounded-full bg-white animate-pulse" title="Customer Waiting" />
        )}
      </div>
      <div className="flex justify-between items-end">
        <div className="flex flex-col">
          <span className="font-mono-tech text-[8px] text-neutral-600 uppercase tracking-tighter mb-0.5">
            Time_In_Stage
          </span>
          <span className="font-mono-tech text-xs font-bold leading-none">{duration}</span>
        </div>
        <div className="text-right">
          <span className="font-mono-tech text-[8px] text-neutral-600 uppercase tracking-tighter mb-0.5 block">
            SLA_Limit
          </span>
          <span className="font-mono-tech text-xs opacity-40 leading-none">{currentStage.slaMinutes}m</span>
        </div>
      </div>
      <div className="mt-3 pt-3 border-t border-white/5 font-mono-tech text-[9px] text-neutral-500 tracking-wide flex justify-between gap-2">
        <span className="truncate">{formattedRevenue}</span>
        <span className="truncate">{(vehicle.technician || '—').toUpperCase()}</span>
        <span className="truncate">{vehicle.sku || '—'}</span>
      </div>
    </div>
  );
};

export default VehicleCard;
